import { upload, region } from 'qiniu-js'
import http from '@xhs/http'
import TokenUniqueUploader from './TokenUniqueUploader'
import {
  QINIU_BUCKET_CDN_MAP, PROD_HOST, LOGAN_HOST, QINIU_TOKEN,
} from './const'

const {
  get,
} = http

const isProd = process.env.NODE_ENV === 'production'
const tokenUrl = `${isProd ? PROD_HOST : LOGAN_HOST}${QINIU_TOKEN}`
export class FileUploader extends TokenUniqueUploader {
    key = ''

    subscriptions = []

    files = []

    constructor({ bucket, bizKey, keyPattern } = {}) {
      if (typeof bucket === 'undefined' || typeof bizKey === 'undefined') {
        throw new Error('[File Uploader Exception]: {bucket} and {bizKey} is required!')
      }
      super({
        bucket,
        bizKey,
        keyPattern,
        postFile({
          file,
          token,
          key,
          onProgress,
          qiniuParam,
        }) {
          return new Promise((resolve, reject) => {
            const putExtra = {}
            const config = {
              useCdnDomain: true,
              region: region.z0,
            }
            const observable = upload(file, key, token, putExtra, config)
            const subscription = observable.subscribe({
              next: ({ total }) => onProgress && onProgress({ total: total.size, ...total }),
              error: err => reject(err),
              complete: res => resolve(res),
            })
            this.files.push(file)
            this.subscriptions.push(subscription)
          }).then(res => ({
            ...res,
            qiniuParam,
            // bucket === picasso 情况下返回没有cdn加速的链接地址bucketUrl
            bucketUrl: QINIU_BUCKET_CDN_MAP[bucket] ? `https://${QINIU_BUCKET_CDN_MAP[bucket].bucketDomain}/${res.key}` : '',
            cdnUrl: QINIU_BUCKET_CDN_MAP[bucket] ? `https://${QINIU_BUCKET_CDN_MAP[bucket].cdnDomain}/${res.key}` : '',
            downloadUrl: QINIU_BUCKET_CDN_MAP[bucket] ? `https://${QINIU_BUCKET_CDN_MAP[bucket].cdnDomain}/${res.key}?attname=${res.key}${res.ext}` : '',
          }))
        },
        getToken(param) {
          return get(tokenUrl, {
            params: {
              // 加上随机数，防止 token 接口被缓存，导致上传异常
              _: Math.random(),
              bucket: this.bucket,
              bizKey: this.bizKey,
              keyPattern: this.keyPattern,
              qiniuParam: param.qiniuParam,
            },
            transform: false,
            withCredentials: false,
          }).then(data => ({
            token: data.token,
            key: data.key,
            qiniuParam: param.qiniuParam,
          }))
        },
      })
    }

    cancel(file) {
      if (file) {
        const index = this.files.indexOf(file)

        if (this.subscriptions[index]) {
          this.subscriptions[index].unsubscribe()
        }
      } else {
        this.subscriptions.forEach(e => { if (e) e.unsubscribe() })
      }
    }
}
